import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import axios from 'axios'
import $ from 'jquery'
import { delete_icon, scale_left_corner_icon, scale_right_corner_icon, rotate_icon } from "./../../../fabricOverrides"

window.fabric.Object.prototype._controlsVisibility = {
  mt: false,
  mb: false,
  ml: false,
  mr: false,
  tr: true,
  tl: true,
  br: true,
  bl: true
};
window.fabric.Object.prototype.drawControls = function(ctx, styleOverride) {
  if (!this.hasControls) {
    return this;
  }

  let wh = this._calculateCurrentDimensions(true),
      width = wh.x,
      height = wh.y,
      left = -(width / 2),
      top = -(height / 2),
      scaleOffset = this.cornerSize / 2,
      methodName = this.transparentCorners ? 'strokeRect' : 'fillRect';

  ctx.save();

  ctx.lineWidth = 1;

  ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
  ctx.strokeStyle = ctx.fillStyle = this.cornerColor;


  // bottom-right
  const scaleImage = new Image();
  scaleImage.src = scale_right_corner_icon;
  ctx.drawImage(scaleImage, left + width - (15/2), top + height - (15/2), 15, 15);
  ctx.drawImage(scaleImage, left + width - (15/2), top + height - (15/2), 15, 15);

  if (!this.get("lockUniScaling")) {
    // middle-top
    this._drawControl(
        "mt",
        ctx,
        methodName,
        left + width / 2,
        top,
        styleOverride
    );

    // middle-bottom
    this._drawControl(
        "mb",
        ctx,
        methodName,
        left + width / 2,
        top + height,
        styleOverride
    );

    // middle-right
    this._drawControl(
        "mr",
        ctx,
        methodName,
        left + width,
        top + height / 2,
        styleOverride
    );

    // middle-left
    this._drawControl(
        "ml",
        ctx,
        methodName,
        left,
        top + height / 2,
        styleOverride
    );
  }

  // middle-top-rotate
  if (this.hasRotatingPoint) {
    this._drawControl('mtr', ctx, methodName,
        left + width/2 - scaleOffset,
        top - this.rotatingPointOffset - scaleOffset);
  }
  // top-left
  const dragImage = new Image();
  dragImage.src = delete_icon;
  ctx.drawImage(dragImage, left - (15/2), top - (15/2), 15, 15);

  // top-right
  const rightImage = new Image();
  rightImage.src = rotate_icon;
  ctx.drawImage(rightImage, left + width - (15/2), top - (15/2), 15, 15);
  /* this._drawControl(rightImage, ctx, methodName,
      left + width,
      top, styleOverride); */

  // bottom-left
  const deleteImage = new Image();
  deleteImage.src = scale_left_corner_icon;
  ctx.drawImage(deleteImage, left - (15/2), top + height - (15/2), 15, 15);

  ctx.restore();

  return this;
};
window.fabric.Canvas.prototype._getActionFromCorner = function(alreadySelected, corner, e) {
  if (!corner || !alreadySelected) {
    return "drag";
  }

  switch (corner) {
    case "bl":
      return "scale";
    case "br":
      return "scale";
    case "tr":
      return "rotate";
    case "tl":
      return "remove";
    case "mtr":
      return "rotate";
    case "ml":
    case "mr":
      return e[this.altActionKey] ? "skewY" : "scaleX";
    case "mt":
    case "mb":
      return e[this.altActionKey] ? "skewX" : "scaleY";
    default:
      return "scale";
  }
};
window.fabric.Canvas.prototype._setCornerCursor = function(corner, target, e) {
  if (
      corner in
      {
        mt: 0, // n
        mr: 2, // e
        mb: 4, // s
        ml: 6, // w
      }
  ) {
    return this._getRotatedCornerCursor(corner, target, e);
  }
  if (corner === "mtr" && target.hasRotatingPoint) {
    this.setCursor(this.rotationCursor);
  }else if (corner === "tl") {
    this.setCursor(this.defaultCursor);
  }else if (corner === "tr") {
    this.setCursor(this.rotationCursor);
  }else if (corner === "bl") {
    this.setCursor("sw-resize");
  }else if(corner === "br"){
    this.setCursor("se-resize")
  }
  else {
    this.setCursor(this.defaultCursor);
  }
  return false;
};
window.fabric.Canvas.prototype._removeAction = function(e,target){
  var _this = this;
  if (this.getActiveGroup() && this.getActiveGroup() !== 'undefined') {
    this.getActiveGroup().forEachObject(function(o) {
      o.off();
      o.remove();
    });
    this.discardActiveGroup();

    // as of fabric 1.6.3 necessary for reasons..
    setTimeout(function() {
      _this.deactivateAll();
    }, 0);

  } else {
    target.off();
    target.remove();

    setTimeout(function() {
      _this.deactivateAll();
    }, 0);
  }
}
window.fabric.Canvas.prototype._setupCurrentTransform = function (e, target) {
  if (!target) {
    return;
  }

  let pointer = this.getPointer(e),
      corner = target._findTargetCorner(this.getPointer(e, true)),
      action = this._getActionFromCorner(target, corner),
      origin = this._getOriginFromCorner(target, corner);
  this._currentTransform = {
    target: target,
    action: action,
    scaleX: target.scaleX,
    scaleY: target.scaleY,
    offsetX: pointer.x - target.left,
    offsetY: pointer.y - target.top,
    originX: origin.x,
    originY: origin.y,
    ex: pointer.x,
    ey: pointer.y,
    left: target.left,
    top: target.top,
    theta: window.fabric.util.degreesToRadians(target.angle),
    width: target.width * target.scaleX,
    mouseXSign: 1,
    mouseYSign: 1
  };

  this._currentTransform.original = {
    left: target.left,
    top: target.top,
    scaleX: target.scaleX,
    scaleY: target.scaleY,
    originX: origin.x,
    originY: origin.y
  };
  if (action === 'remove') {
    console.log(target);
    let _this = this;
    let canvas = target.canvas;
    canvas.remove(target);

    setTimeout(function() {
      _this.deactivateAll();
    }, 0);
  }
  this._resetCurrentTransform(e);
}
window.fabric.Canvas.prototype._drawSelection  = function () {
  console.log("_drawSelection")
  let ctx = this.contextTop,
      groupSelector = this._groupSelector,
      left = groupSelector.left,
      top = groupSelector.top,
      aleft = Math.abs(left),
      atop = Math.abs(top);

  ctx.fillStyle = this.selectionColor;

  ctx.fillRect(
      groupSelector.ex - ((left > 0) ? 0 : -left),
      groupSelector.ey - ((top > 0) ? 0 : -top),
      aleft,
      atop
  );

  ctx.lineWidth = this.selectionLineWidth;
  ctx.strokeStyle = this.selectionBorderColor;

  // selection border
  if (this.selectionDashArray.length > 1) {

    var px = groupSelector.ex + 0.5 - ((left > 0) ? 0: aleft),
        py = groupSelector.ey + 0.5 - ((top > 0) ? 0: atop);

    ctx.beginPath();

    window.fabric.util.drawDashedLine(ctx, px, py, px + aleft, py, this.selectionDashArray);
    window.fabric.util.drawDashedLine(ctx, px, py + atop - 1, px + aleft, py + atop - 1, this.selectionDashArray);
    window.fabric.util.drawDashedLine(ctx, px, py, px, py + atop, this.selectionDashArray);
    window.fabric.util.drawDashedLine(ctx, px + aleft - 1, py, px + aleft - 1, py + atop, this.selectionDashArray);

    ctx.closePath();
    ctx.stroke();
  }
  else {
    ctx.strokeRect(
        groupSelector.ex + 0.5 - ((left > 0) ? 0 : aleft),
        groupSelector.ey + 0.5 - ((top > 0) ? 0 : atop),
        aleft,
        atop
    );
  }
}


class DesignCanvas extends React.Component {
  static propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }

  static defaultProps = {
    width: 400,
    height: 400,
  }

  state = {
    canvas: null,
    canvas_width: 400,
    canvas_height: 400,
  }

  componentDidUpdate() {
    const load_design = this.props.load_design
    const saved_id = this.props.saved_id
    if (load_design) {
      axios
        .post('/api/load_design', { id: saved_id })
        .then(res => {
          let tempConfig = res.data

          const objects = tempConfig.objects
          const wrestling_config = tempConfig.wrestling_config;
          if(wrestling_config) {
            this.props.setWrestingSettingConfig(wrestling_config);
          }
          let objs = null

          objects.map((object, idx) => {
            switch (object.type) {
              case 'circle':
                object.lockMovementX = true
                object.lockMovementY = true
                object.lockUniScaling = true
                object.lockScalingX = true
                object.lockScalingY = true
                break;
              case 'group':
                objs = object.objects
                objs.map(obj => {
                  obj.lockMovementX = true
                  obj.lockMovementY = true
                  obj.lockUniScaling = true
                  obj.lockScalingX = true
                  obj.lockScalingY = true
                })
                break;
              default:
                break;
            }
          })

          this.props.canvas.loadFromJSON(tempConfig, () => {
            objs = this.props.canvas.getObjects()
            objs.map((obj, idx) => {

              if (obj.type === 'curvedText') {

                let isVertical = obj.effect === 'vertical' ? true : false

                obj.letters._objects.map(o => (o.originalLeft = 0))
                let style = {
                  angle: obj.angle,
                  reverse: obj.reverse,
                  fontFamily: obj.fontFamily,
                  fontSize: obj.fontSize,
                  fontStyle: obj.fontStyle,
                  fontWeight: obj.fontWeight,
                  fill: obj.fill,
                  effect: isVertical ? "STRAIGHT" : obj.effect,
                  radius: obj.radius,
                  top: obj.top,
                  left: obj.left,
                  lineHeight: obj.lineHeight,
                  spacing: obj.spacing,
                  stroke: obj.stroke,
                  strokeWidth: obj.strokeWidth,
                  textAlign: obj.textAlign,
                }
                let replaceText = new window.fabric.CurvedText(obj.text, style)
                this.props.canvas.remove(obj)
                this.props.canvas.insertAt(replaceText, idx, false)

                if (isVertical) {
                  replaceText.set({angle:0,effect:"vertical"});
                }
              }
            })
          })

          // Initializing Undo and Redo buttons for saved designs
          tempConfig.canvasState = []
          tempConfig.currentStateIndex = 0
          tempConfig.undoStatus = false
          tempConfig.redoStatus = false
          tempConfig.undoFinishedStatus = 1
          tempConfig.redoFinishedStatus = 1
          tempConfig.undoButton = ""
          tempConfig.redoButton = ""	  

          this.props.canvas.renderAll()
          this.props.setCanvasConfig(tempConfig)
	        this.updateCanvasState()
          this.props.setDisableLoad()
        })
    }

    const config = this.props.wrestling_config
    if (config.isNewMaterial) {
      let config = this.props.wrestling_config
      config.isNewMaterial = false
      this.props.setWrestlingConfig(
        config.width,
        config.height,
        config.isNewMaterial,
        config.file,
      )

      const grid = this.props.width / config.width
      const width = grid * config.width
      const height = grid * config.height

      this.props.setImageUrl(require('./../../../assets/img/mat-desing.jpg'))
      window.fabric.Image.fromURL(
        require(`./../../../assets/img/${config.file}`),
        image => {
          this.props.canvas.setBackgroundImage(
            image,
            this.props.canvas.renderAll.bind(this.props.canvas),
            {
              top: 0,
              left: 0,
              width: width,
              height: height,
            },
          )
        },
      )
      this.updateDirectCanvasState(this.props.canvas)
    }
  }

  showPanel = (nav) => {
    if (nav === 'mySidenav8') return '#artwork-color-panel.second-menu'
    if (nav === 'mySidenav7') return '#circle-color-pane.second-menu'
    if (nav === 'mySidenav6') return '#thickness.second-menu'
    if (nav === 'mySidenav5') return '#artwrl.second-menu'
    if (nav === 'mySidenav4') return '#text.second-menu'
    if (nav === 'mySidenav3') return '#circle.second-menu'
    if (nav === 'mySidenav2') return '#color.second-menu'
    if (nav === 'mySidenav1') return '#mats.second-menu'
  }

  showEmptyZone = (width, area) => {
    const emptyArea = document.getElementById("second-custom-right");

    if (emptyArea) {
      setTimeout(() => {
        const panel = this.showPanel(area)

        panel && $(panel).show()
        emptyArea.style.display = 'block';
        emptyArea.style.width = `calc(100% - ${width}px)`;
      }, 300);
    }
  }
  componentDidMount() {
    const canvas = new window.fabric.Canvas(this.c)
    // for testing only
    window.Canvas = canvas;
    const config = this.props.wrestling_config
    const grid = this.props.width / config.width
    const width = grid * config.width
    const height = grid * config.height

    if (!this.props.load_design) {
      const t = new window.fabric.Text('', { fontFamily: 'Times New Roman' })
      canvas.add(t)

      this.props.setImageUrl(require(`./../../../assets/img/${config.file}`))
      window.fabric.Image.fromURL(
        require('./../../../assets/img/42x42.png'),
        image => {
          canvas.setBackgroundImage(image, canvas.renderAll.bind(canvas), {
            top: 0,
            left: -1,
            width: width,
            height: height,
          })
        },
      )
      this.updateDirectCanvasState(canvas)
    }

    this.props.setCanvas(canvas)

    canvas.on('mouse:down',e=>{
      if(this.checkBrowser()){
        let activeObject = this.props.canvas.getActiveObject();
        if(activeObject){
          $('.custom-main-content').css({overflow:'hidden'});
          this.setState({
            isDragging:true,
          })
        }
      }
    })

    canvas.on('mouse:up', e=>{
      if(this.checkBrowser()){
        let activeObject = this.props.canvas.getActiveObject();
        if(activeObject){
          $('.custom-main-content').css({overflow:'auto'});
          this.setState({
            isDragging:true,
          })
        }
      }

      if(!this.checkBrowser()){
        return;
      }
      let activeObject = this.props.canvas.getActiveObject();
      if (activeObject &&(
          activeObject.__proto__.type === 'text' ||
          activeObject.__proto__.type === 'curvedText'
      )) {
        this.textSelectionCreated(activeObject)
        $('.second-menu').hide()
          this.showEmptyZone(300, 'mySidenav4')

      }
      else if (activeObject && activeObject.__proto__.type === 'image') {
        $('.material-color-pane').css({ display: 'block' })
        $('.circle-color-pane').css({ display: 'none' })
        $('.text-color-pane').css({ display: 'none' })
        $('.artwork-color-pane').css({ display: 'none' })
      }
      else if (activeObject && activeObject.__proto__.type === 'circle') {
        document.getElementById("mySidenav7").style.width = "300px";
        $('.second-menu').hide()
        this.showEmptyZone(300, 'mySidenav7')
        $(`#menu li.nav.active`).removeClass('active')
        //$('.circle-color-pane').css({ display: 'block' })
        $('.text-color-pane').css({ display: 'none' })
        $('#custom').css('display', 'block')
        $('#text-custom').css('display', 'none')
        $('.advanced_span').css('display', 'none')
        $('.custom-colors').css('display', 'block')
        $(".advanced_span").css("display", "block");
        $('.default-color-2').css({
          background: activeObject.get('stroke'),
        })
        $('.default-color-1').css({
          background: activeObject.get('fill'),
        })
        if (activeObject.get('fill') === 'rgba(0,0,0,0)')
          $('.default-colors .default-color-1').css('visibility', 'hidden')
        else $('.default-colors .default-color-1').css('visibility', 'visible')

        $('.default-colors .default-color-3').css('visibility', 'hidden')
        let selectedStrokeColor = activeObject.get('stroke')
        $('#circle-color-bind').css('background', selectedStrokeColor)

      }
      else if (activeObject && activeObject.__proto__.type === 'path-group') {
        //$('#artwork-custom').css({ display: 'block' })
        document.getElementById("mySidenav8").style.width = "300px";
        $('.second-menu').hide()
        this.showEmptyZone(300, 'mySidenav8')
        $('.artwork-color-pane .custom-colors div.active').removeClass('active')
        //$('.artwork-custom-color').addClass('active')
        $('.custom-colors').css('display', 'block')
        //$('#artwork-custom').css({ display: 'block' })
        $('#artwork-rgb').css({ display: 'none' })
        $('#artwork-cmyk').css({ display: 'none' })
        $('.circle-color-pane').css({ display: 'none' })
        $('.text-color-pane').css({ display: 'none' })
        $(".advanced_span").css("display", "block");
        const paths = activeObject.paths
        let colors = []
        let pathsArray = []
        for (let i = 0; i < paths.length; i++) {
          const color = paths[i].getFill()
          const index = colors.indexOf(color)
          if (index < 0) {
            let temp = []
            colors.push(color)
            temp.push(i)
            pathsArray.push(temp)
            $(
                `.default-color-${colors.length}`,
            ).css('background', color)
          } else pathsArray[index].push(i)
        }
        this.props.setCurrentArtworkPath(pathsArray)
        $('#artwork-color-pane').show()
        $(`#menu li.nav.active`).removeClass('active')
        //$('.artwork-color-pane').css({ display: 'block' })
      }
      else if(activeObject){
        console.log('in here')
        $('.default-color-1').css({
          background: activeObject._objects[0].get('stroke'),
        })
        $('.default-color-2').css({
          background: activeObject._objects[1].get('stroke'),
        })
        $('.default-color-3').css({
          background: activeObject._objects[3].get('stroke'),
        })
        $('.default-colors .default-color-1').css('visibility', 'visible')
        $('.default-colors .default-color-3').css('visibility', 'visible')
        $('.material-color-pane').css({ display: 'none' })
        $('.circle-color-pane').css({ display: 'block' })
        $('.custom-colors').css({ display: 'block' })
        $('.text-color-pane').css({ display: 'none' })
        $('#custom').css('display', 'block')
        $('#rgb').css('display', 'none')
        $('#cmyk').css('display', 'none')
        $('#text-custom').css('display', 'none')
        $('.advanced_span').css('display', 'none')
        $('.custom-colors').css('display', 'block')
        $(".advanced_span").css("display", "block");
        document.getElementById("mySidenav7").style.width = "300px";
        this.showEmptyZone(300, 'mySidenav7')
      }
    })

    canvas.on('object:selected', e => {
      let activeObject = this.props.canvas._activeObject;
      console.log('object:selected', activeObject)
      if(activeObject === null){
        this.props.canvas.deactivateAll().renderAll();
        return;
      }
      if(this.checkBrowser()){
        return;
      }
      if (activeObject &&(
        activeObject.__proto__.type === 'text' ||
        activeObject.__proto__.type === 'curvedText'
      )) {
        this.textSelectionCreated(activeObject);
        $('.second-menu').hide()
        $('#text').show()
      }
      else if (activeObject.__proto__.type === 'image') {
        $('.material-color-pane').css({ display: 'block' })
        $('.circle-color-pane').css({ display: 'none' })
        $('.text-color-pane').css({ display: 'none' })
        $('.artwork-color-pane').css({ display: 'none' })
      }
      else if (activeObject.__proto__.type === 'circle') {
        console.log(activeObject)
        $('.second-menu').hide()
        $('#circle-color-pane').show()
        $(`#menu li.nav.active`).removeClass('active')
        //$('.circle-color-pane').css({ display: 'block' })
        $('.text-color-pane').css({ display: 'none' })
        $('#custom').css('display', 'block')
        $('#text-custom').css('display', 'none')
        $('.advanced_span').css('display', 'none')
        $('.custom-colors').css('display', 'block')
        $(".advanced_span").css("display", "block");
        $('.default-color-2').css({
          background: activeObject.get('stroke'),
        })
        $('.default-color-1').css({
          background: activeObject.get('fill'),
        })
        if (activeObject.get('fill') === 'rgba(0,0,0,0)')
          $('.default-colors .default-color-1').css('visibility', 'hidden')
        else $('.default-colors .default-color-1').css('visibility', 'visible')

        $('.default-colors .default-color-3').css('visibility', 'hidden')
        let selectedStrokeColor = activeObject.get('stroke')
        $('#circle-color-bind').css('background', selectedStrokeColor)

      }
      else if (activeObject && activeObject.__proto__.type === 'path-group') {
        //$('#artwork-custom').css({ display: 'block' })
        $('.artwork-color-pane .custom-colors div.active').removeClass('active')
        $('.artwork-custom-color').addClass('active')
        $('.custom-colors').css('display', 'block')
        $('#artwork-custom').css({ display: 'block' })
        $('#artwork-rgb').css({ display: 'none' })
        $('#artwork-cmyk').css({ display: 'none' })
        $('.circle-color-pane').css({ display: 'none' })
        $('.text-color-pane').css({ display: 'none' })
        $(".advanced_span").css("display", "block");
        const paths = activeObject.paths
        let colors = []
        let pathsArray = []
        for (let i = 0; i < paths.length; i++) {
          const color = paths[i].getFill()
          const index = colors.indexOf(color)
          if (index < 0) {
            let temp = []
            colors.push(color)
            temp.push(i)
            pathsArray.push(temp)
            $(
              `.default-color-${colors.length}`,
            ).css('background', color)
          } else pathsArray[index].push(i)
        }
        this.props.setCurrentArtworkPath(pathsArray)
        $('.second-menu').hide()
        $('#artwork-color-pane').show()
        $(`#menu li.nav.active`).removeClass('active')
        //$('.artwork-color-pane').css({ display: 'block' })
      }
      else {
        console.log('in here')
        $('.default-color-1').css({
          background: activeObject._objects[0].get('stroke'),
        })
        $('.default-color-2').css({
          background: activeObject._objects[1].get('stroke'),
        })
        $('.default-color-3').css({
          background: activeObject._objects[3].get('stroke'),
        })
        $('.second-menu').hide()
        $('#circle-color-pane').show()
        $('.default-colors .default-color-1').css('visibility', 'visible')
        $('.default-colors .default-color-3').css('visibility', 'visible')
        $('.material-color-pane').css({ 'display': 'none' })
        $('.circle-color-pane').css({ 'display': 'block' })
        $('.text-color-pane').css({ 'display': 'none' })
        $('#custom').css('display', 'block')
        $('#rgb').css('display', 'none')
        $('#cmyk').css('display', 'none')
        $('#text-custom').css('display', 'none')
        $('.advanced_span').css('display', 'none')
        $('.custom-colors').css('display', 'block')
        $(".advanced_span").css("display", "block");
      }

      setTimeout(()=>{
        this.props.canvas.renderAll();
      },100);
    })

    canvas.on('selection:cleared', () => {
      // $('.second-menu').hide()
      //$('#mats').show()
      $(`#menu li.nav.active`).removeClass('active')
      //$(`#menu li.nav.mats`).addClass('active')
      if(!this.checkBrowser()) {
        $(".second-menu").hide();
        $('#mats').show()
        $(`#menu li.nav.active`).removeClass('active')
        $(`#menu li.nav.mats`).addClass('active')
      }else{
        document.getElementById("mySidenav1").style.width = "0px";
        document.getElementById("mySidenav2").style.width = "0px";
        document.getElementById("mySidenav3").style.width = "0px";
        document.getElementById("mySidenav11") && (document.getElementById("mySidenav11").style.width = "0");
        setTimeout(()=>{this.textSelectionCleared()}, 300);
        //document.getElementById("mySidenav11").style.width = "0px";
        document.getElementById("mySidenav5").style.width = "0px";
        document.getElementById("mySidenav6").style.width = "0px";
        document.getElementById("mySidenav7").style.width = "0px";
      }
    })

    canvas.on('object:added', (e) => {
      // if (!this.props.load_design) this.updateCanvasState()
      let object  = e.target;
      object.set({
        //transparentCorners: false,
        cornerStrokeColor: '#343131',
        borderColor: '#343131',
        cornerSize: 12,
        padding: 10,
        //borderDashArray: [5, 5],
        selectionDashArray: [5, 5]
      })
      setTimeout(()=>{
        this.props.canvas.renderAll();
      },100);
    })

    canvas.on('object:moving', e => {
    })

    canvas.on('object:modified', e => {
      if (!this.props.load_design) this.updateCanvasState()
    })
  }

  textSelectionCreated=(text)=>{
    let newTextPanelConfig = {
      text: text.text,
      fontSize: 20,
      fontFamily: text.get("fontFamily"),
      fontWeight: text.get("fontWeight"),
      fontStyle: text.get("fontStyle"),
      text_align:text.get('textAlign'),
      textDecoration: text.get("textDecoration"),
      lineHeight: text.get("lineHeight"),
      fill: text.get("fill"),
      strokeWidth: text.get("strokeWidth") / 1,
      stroke: text.get("stroke"),
      letterSpace: text.letterSpace,
      effect: text.get("effect")
    };
    this.props.setTextConfigPanel(true , newTextPanelConfig)
  }
  textSelectionCleared=()=>{
    let newTextPanelConfig = {
      text:'Add Text',
      fontFamily:'Times New Roman',
      fontSize:20,
      fontWeight: '',
      fontStyle: '',
      text_align:'left',
      textDecoration: '',
      lineHeight: '1',
      fill: 'black',
      strokeWidth: '',
      stroke: null,
      letterSpace: '1',
      effect:'STRAIGHT'
    };
    this.props.setTextConfigPanel(false , newTextPanelConfig)
  }


  updateDirectCanvasState = canvas => {
    let tempConfig = this.props._config
    if (tempConfig.undoStatus === false && tempConfig.redoStatus === false) {
      let jsonData = canvas.toJSON(['source'])
      let canvasAsJson = JSON.stringify(jsonData)
      if (tempConfig.currentStateIndex < tempConfig.canvasState.length - 1) {
        let indexToBeInserted = tempConfig.currentStateIndex + 1
        tempConfig.canvasState[indexToBeInserted] = canvasAsJson

        let numberOfElementsToRetain = indexToBeInserted + 1
        tempConfig.canvasState = tempConfig.canvasState.splice(
          0,
          numberOfElementsToRetain,
        )
      } else {
        tempConfig.canvasState.push(canvasAsJson)
      }

      tempConfig.currentStateIndex = tempConfig.canvasState.length - 1

      if (
        tempConfig.currentStateIndex === tempConfig.canvasState.length - 1 &&
        tempConfig.currentStateIndex !== -1
      ) {
        tempConfig.redoButton = 'disabled'
      }
    }
    this.props.setCanvasConfig(tempConfig)
  }

  deleteSelectedText = () => {
    let activeObject = this.props.canvas._activeObject
    if (activeObject) {
      this.props.canvas.remove(activeObject)
      this.updateCanvasState()
    }
  }
  checkBrowser=()=>{
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };

  updateCanvasState = () => {
    let tempConfig = this.props._config
    if (tempConfig.undoStatus === false && tempConfig.redoStatus === false) {
      let jsonData = this.props.canvas.toJSON(['source','isCenterCircle'])
      let canvasAsJson = JSON.stringify(jsonData)
      if (tempConfig.currentStateIndex < tempConfig.canvasState.length - 1) {
        let indexToBeInserted = tempConfig.currentStateIndex + 1
        tempConfig.canvasState[indexToBeInserted] = canvasAsJson

        let numberOfElementsToRetain = indexToBeInserted + 1
        tempConfig.canvasState = tempConfig.canvasState.splice(
          0,
          numberOfElementsToRetain,
        )
      } else {
        tempConfig.canvasState.push(canvasAsJson)
      }
      tempConfig.currentStateIndex = tempConfig.canvasState.length - 1

      if (
        tempConfig.currentStateIndex === tempConfig.canvasState.length - 1 &&
        tempConfig.currentStateIndex !== -1
      ) {
        tempConfig.redoButton = 'disabled'
      }
    }
    this.props.setCanvasConfig(tempConfig)
  }

  render() {
    const children = React.Children.map(this.props.children, child => {
      return React.cloneElement(child, {
        canvas: this.props.canvas,
      })
    })

    const config = this.props.wrestling_config
    const grid = this.props.width / config.width
    const width = grid * config.width
    const height = grid * config.height
    console.warn(height,width)
    return (
      <Fragment>
        <canvas ref={c => (this.c = c)} width={400} height={400} />
        {this.props.canvas && children}
        <img
          className="deleteBtn"
          src={require('./../../../assets/img/delete.png')}
          alt="delteBtn"
          style={{
            width: '20px',
            height: '20px',
            position: 'absolute',
            visibility: 'hidden',
          }}
          onClick={this.deleteSelectedText}
        />
      </Fragment>
    )
  }
}

const setCanvas = canvas => {
  return {
    type: 'SET_CANVAS',
    canvas: canvas,
  }
}

const setCanvasConfig = _config => {
  return {
    type: 'SET_CONFIG',
    _config,
  }
}

const setDisableLoad = () => {
  return {
    type: 'DISABLE_DESIGN_LOAD',
  }
}

const setWrestlingConfig = (width, height, isNewMaterial, file) => {
  const data = {
    width: width,
    height: height,
    length_unit: 'METER',
    isNewMaterial: isNewMaterial,
    file: file,
  }
  return {
    type: 'SET_WRESTLING_CONFIG',
    _config: data,
  }
}

const clearCanvas = () => {
  return {
    type: 'CLAER_CANVAS',
    isCanvasCleared: false,
  }
}

// custom
const setImageUrl = url => {
  return {
    type: 'SET_IMAGE_URL',
    image_url: url,
  }
}

const addNewImage = image => {
  return {
    type: 'NEW_IMAGE',
    component: image,
  }
}

const setCurrentArtworkPath = paths => {
  return {
    type: 'ARTWRORK_PATH',
    paths,
  }
}
const setTextConfigPanel = (status , text_toolbar_config)=>{
  return {
    type: 'TEXT_TOOLBAR_CONFIG',
    is_text_toolbar_active:status,
    text_toolbar_config
  }
}
const setWrestingSettingConfig = (_config) => {
  return {
    type: 'SET_WRESTLING_SETTING_CONFIG',
    _config
  }
}

const mapStateToProps = state => {
  return {
    canvas: state.canvas,
    _config: state._config,
    load_design: state.load_design,
    saved_id: state.saved_id,
    wrestling_config: state.wrestling_config,
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      setCanvasConfig,
      setDisableLoad,
      setCanvas,
      clearCanvas,
      setImageUrl,
      addNewImage,
      setWrestlingConfig,
      setCurrentArtworkPath,
      setTextConfigPanel,
      setWrestingSettingConfig
    },
    dispatch,
  )
}

const DesignCanvasState = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DesignCanvas)

export default DesignCanvasState
